




$('.product-container:not(.our-tools__slider)').slick({
  slidesToShow: 3,
  slidesToScroll: 3,
  dots: true,
  autoplay: true,
  infinite: false,
  autoplaySpeed: 5000,
  prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button"><svg width="34" height="23" viewBox="0 0 34 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4067 21.6499L1.99986 11.1143L12.4067 0.613956" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/><path d="M2.00066 11.1143L34 11.1143" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/></svg></button>',
  nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button"><svg width="34" height="23" viewBox="0 0 34 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4067 21.6499L1.99986 11.1143L12.4067 0.613956" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/><path d="M2.00066 11.1143L34 11.1143" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
       autoplay: true,
        dots: true
      }
    },
    {
      breakpoint: 981,
      settings: {
        slidesToShow: 1,
      autoplay: true,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
       autoplay: true,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});




$('.qtybox .btnqty').on('click', function(){
var value = $(this).parent('.qtybox').find('.quantity-input').val()
  var qty = parseInt(value);
  if($(this).hasClass('qtyplus')) {
    qty++;
  }else {
    if(qty > 1) {
      qty--;
    }
  }
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.qtybox').find('.quantity-input').val(qty);

}); 

$('.site-footer__logo-image').click(function(e){
    e.preventDefault();
    window.scrollTo(0,0);
});


$("#other").click(function() {
   $("#product-button").click();
});


$('.image-thumb-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: true,
  adaptiveHeight: true,
  prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button"><svg width="34" height="23" viewBox="0 0 34 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4067 21.6499L1.99986 11.1143L12.4067 0.613956" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/><path d="M2.00066 11.1143L34 11.1143" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/></svg></button>',
  nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button"><svg width="34" height="23" viewBox="0 0 34 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4067 21.6499L1.99986 11.1143L12.4067 0.613956" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/><path d="M2.00066 11.1143L34 11.1143" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/></svg></button>',
  responsive: [ 
  	{
    	breakpoint: 767,
      	settings: {
        	slidesToShow: 1,
        	slidesToScroll: 1,
        	infinite: true,
            // centerMode: true,
            // adaptiveHeight: true,
      	}
    }
  ],
  asNavFor: '.image-thumb-slider-nav',
      	
});
$('.image-thumb-slider-nav').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  asNavFor: '.image-thumb-slider',
  focusOnSelect: true,
  arrows: false,
  infinite: false,
  dots: true
});

$('.image-thumb-slider').slickLightbox().on({
    'show.slickLightbox': function(){ 
      var lgt_nav_html = '<div class="light-box-navs">';
          lgt_nav_html += '<button type="button" data-role="none" class="custom-lgtbx-slick-nav slick-prev slick-arrow" aria-label="Previous" role="button" style="display: block;">Previous</button>';
          lgt_nav_html += '<button type="button" data-role="none" class="custom-lgtbx-slick-nav slick-next slick-arrow" aria-label="Next" role="button" style="display: block;">Next</button>';
          lgt_nav_html += '</div>';
      $('.slick-lightbox-inner .slick-lightbox-slick').append(lgt_nav_html);
      var cstm_first_lightbox_img = $('.slick-lightbox-inner .slick-lightbox-slick').find('.slick-slide.slick-current.slick-active img').width();
      $('.slick-lightbox-inner .slick-lightbox-slick .light-box-navs').width(cstm_first_lightbox_img+'px');
    }
});



$('.image-thumb-slider-nav .slick-list .slick-track .thumb-main-nav').each(function(i){
  let src = $(this).find('img').attr('src');
  $('.image-thumb-slider-nav .slick-dots li[role="presentation"]:nth-child('+(i+1)+')').append('<img src="'+src+'">');
});


$(document).ready(function(){
  $("body").on("click", ".support-three-button .first-btn li", function(){

    if ($(this).hasClass('active-filter')) {
      $('.support-three-button .first-btn li').removeClass('inactive-filter');
      $('.support-three-button .first-btn li').removeClass('active-filter');

      $(this).find('.remove-fltr-icn').text('');
      $('.support-container .grid-container .item1').addClass("active");
    } else {
      var fltr_tg_nm = $(this).children().data('filter-tag-name');
    
      $('.support-three-button .first-btn li').addClass('inactive-filter');
      $('.support-three-button .first-btn li').removeClass('active-filter');
      $(this).removeClass('inactive-filter');
      $(this).addClass('active-filter');
  
      $('.support-three-button .first-btn li .remove-fltr-icn').text('');
      $(this).find('.remove-fltr-icn').text('x');
            
      $('.support-container .grid-container .item1').removeClass("active");
      $(`.support-container .grid-container .${fltr_tg_nm}`).addClass("active");
    }

  });

  $("body").on("click", ".slick-lightbox-inner .slick-lightbox-slick .light-box-navs .slick-next.slick-arrow", function(){
    $('.slick-lightbox-inner .slick-lightbox-slick >.slick-next.slick-arrow').click();
  });

  $("body").on("click", ".slick-lightbox-inner .slick-lightbox-slick .light-box-navs .slick-prev.slick-arrow", function(){
    $('.slick-lightbox-inner .slick-lightbox-slick >.slick-prev.slick-arrow').click();
  });

  $("body").on("click", ".slick-lightbox .slick-lightbox-slick .custom-lgtbx-slick-nav.slick-arrow", function(){
    $(this).addClass('farftetewe');
    $this = $(this);
    setTimeout(function () {
      var curr_img_wid = $this.parent().parent().find('.slick-slide.slick-current.slick-active img').width();
      $('.slick-lightbox-inner .slick-lightbox-slick .light-box-navs').width(curr_img_wid+'px');
    }, 200);
    
  });
  if ($(window).width() < 960) {
    setTimeout(function () {
      $('.start-slider-frome-here .only-mobile-view-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      focusOnSelect: true,
      autoplay: true,
      prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button"><svg width="34" height="23" viewBox="0 0 34 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4067 21.6499L1.99986 11.1143L12.4067 0.613956" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/><path d="M2.00066 11.1143L34 11.1143" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/></svg></button>',
      nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button"><svg width="34" height="23" viewBox="0 0 34 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4067 21.6499L1.99986 11.1143L12.4067 0.613956" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/><path d="M2.00066 11.1143L34 11.1143" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/></svg></button>',
      arrows: true,
      infinite: true,
      dots: true
      });
    }, 2000); 
  } 
});

jQuery(function() { 
  $('.single-option-selector').each(function() {
    let option_index = $(this).data('option-index');
    let value = $(this).find(":selected").val();
    $(`.swatch[data-option-index="${option_index}"] input[value="${value}"]`).prop('checked', true);
  })
  
  jQuery('.swatch :radio').change(function() {
    var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
    var optionValue = jQuery(this).val();
    console.log('x', optionIndex, optionValue);
    jQuery(this)
      .closest('form')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');
    document.querySelector('.single-option-selector').dispatchEvent(new Event('change'));
  });
});

$(document).ready(function(){
$('.our-tools__home .product-container').slick({
  slidesToShow: 3,
  slidesToScroll: 2,
  infinite: false,
  arrows: true,
  dots: true,
  autoplay: true,
  autoplaySpeed: 5000,
    prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button"><svg width="34" height="23" viewBox="0 0 34 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4067 21.6499L1.99986 11.1143L12.4067 0.613956" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/><path d="M2.00066 11.1143L34 11.1143" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/></svg></button>',
    nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button"><svg width="34" height="23" viewBox="0 0 34 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4067 21.6499L1.99986 11.1143L12.4067 0.613956" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/><path d="M2.00066 11.1143L34 11.1143" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/></svg></button>',
  responsive: [ 
    {
      breakpoint: 981,
      settings: {
        slidesToShow: 2,
        autoplay: true,
        slidesToScroll: 1
      }
    },
      {
      breakpoint: 749,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
      	
});


    $('.pre_order_main .pre_order_product_wrapper').slick({
        slidesToShow: 4,
      slidesToScroll: 4,
  arrows: false,
  dots: false,
  // autoplay: true,
  // autoplaySpeed: 5000,
    prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button"><svg width="34" height="23" viewBox="0 0 34 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4067 21.6499L1.99986 11.1143L12.4067 0.613956" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/><path d="M2.00066 11.1143L34 11.1143" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/></svg></button>',
  nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button"><svg width="34" height="23" viewBox="0 0 34 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4067 21.6499L1.99986 11.1143L12.4067 0.613956" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/><path d="M2.00066 11.1143L34 11.1143" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/></svg></button>',
responsive: [ 

      {
      breakpoint: 749,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows:true,
        dots:true
      }
    }
  ]
      	
});

$('.replacement-parts .replacement-product-container').slick({
        slidesToShow: 3,
      slidesToScroll: 2,
  arrows: true,
  dots: true,
  autoplay: true,
  autoplaySpeed: 5000,
    prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button"><svg width="34" height="23" viewBox="0 0 34 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4067 21.6499L1.99986 11.1143L12.4067 0.613956" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/><path d="M2.00066 11.1143L34 11.1143" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/></svg></button>',
  nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button"><svg width="34" height="23" viewBox="0 0 34 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4067 21.6499L1.99986 11.1143L12.4067 0.613956" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/><path d="M2.00066 11.1143L34 11.1143" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/></svg></button>',
responsive: [ 
  	{
    	breakpoint: 749,
      	settings: {
        	slidesToShow: 1,
        	slidesToScroll: 1
      	}
    }
  ]
      	
});
    
  $('.support_grid .load_more_btn').click(function(){
      $('.support_grid .grid-container .support_grid_item').removeClass('hide');
    $(this).parent('.load_more_btn_wrapper').addClass('hide');
  });  


  //     if($(window).width() < 749) {
  //   setTimeout(function () {
  //     $('.product-recommendations__inner .product_recommendations_slider').slick({
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     focusOnSelect: true,
  //     // autoplay: true,
  //     prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button"><svg width="34" height="23" viewBox="0 0 34 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4067 21.6499L1.99986 11.1143L12.4067 0.613956" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/><path d="M2.00066 11.1143L34 11.1143" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/></svg></button>',
  //     nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button"><svg width="34" height="23" viewBox="0 0 34 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4067 21.6499L1.99986 11.1143L12.4067 0.613956" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/><path d="M2.00066 11.1143L34 11.1143" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/></svg></button>',
  //     arrows: true,
  //     infinite: true,
  //     dots: true
  //     });
  //   }, 2000); 
  // } 

$window = $(window);
settings = {
        slidesToShow: 1,
      slidesToScroll: 1,
      focusOnSelect: true,
      // autoplay: true,
      prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button"><svg width="34" height="23" viewBox="0 0 34 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4067 21.6499L1.99986 11.1143L12.4067 0.613956" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/><path d="M2.00066 11.1143L34 11.1143" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/></svg></button>',
      nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button"><svg width="34" height="23" viewBox="0 0 34 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4067 21.6499L1.99986 11.1143L12.4067 0.613956" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/><path d="M2.00066 11.1143L34 11.1143" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/></svg></button>',
      arrows: true,
      infinite: true,
      dots: true
};
if ($window.width() < 749) {
  setTimeout(function () {
    $slick_slider = $('.product-recommendations__inner .product_recommendations_slider');
    $slick_slider.slick(settings);
  }, 2000); 
}
   

$window.on('resize', function() {
       $slick_slider = $('.product-recommendations__inner .product_recommendations_slider');
  if ($window.width() < 749) {
    
    if ($slick_slider.hasClass('slick-initialized')){
      $slick_slider.slick('unslick');
    }

      if ( ! $slick_slider.hasClass('slick-initialized')){
     $slick_slider.slick(settings);
      }
  }else{
        if ($slick_slider.hasClass('slick-initialized')){
      $slick_slider.slick('unslick');
    }
  }
});  

    
});



$(document).ready(function(){

function slider_enable() {
    $('.upsellpro .grid--view-items').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      autoplay: false,
     // autoplaySpeed: 5000,
      prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button"><svg width="34" height="23" viewBox="0 0 34 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4067 21.6499L1.99986 11.1143L12.4067 0.613956" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/><path d="M2.00066 11.1143L34 11.1143" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/></svg></button>',
      nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button"><svg width="34" height="23" viewBox="0 0 34 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4067 21.6499L1.99986 11.1143L12.4067 0.613956" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/><path d="M2.00066 11.1143L34 11.1143" stroke="#C8C8C8" stroke-width="1.5" stroke-miterlimit="10"/></svg></button>',
      responsive: [
            {
            breakpoint: 749,
            settings: {
              settings: "unslick",
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
    });
}

// slider_enable();
$(window).resize(function(){
    var $windowWidth = $(window).width();
    if ($windowWidth < 767) {
        slider_enable();   
    }
});
  
  
});

// cart page quantity

  // $('.cart__qty .qtybox .btnqty').on('click', function(){
  //   var qty = parseInt($(this).parent('.qtybox').find('.cart__qty-input').val());
  //   if($(this).hasClass('qtyplus')) {
  //     qty++;
  //   }else {
  //     if(qty > 1) {
  //       qty--;
  //     }
  //   }
  //   qty = (isNaN(qty))?1:qty;
  //   $(this).parent('.qtybox').find('.cart__qty-input').val(qty);
  // }); 


// product page slider

// Wait for the document to be ready
$(document).ready(function() {
    // Init fancyBox
    $("[data-fancybox]").fancybox({
        selector: '.main-slider .slick-slide:not(.slick-cloned)',
        hash: false
    });

    var prevArrow = '<button type="button" class="slick-prev slick-arrow new_call"><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle opacity="0.66" cx="22" cy="22" r="22" transform="rotate(-180 22 22)" fill="white"/><path d="M24 26L20 22L24 18" stroke="#AFAFAF" stroke-width="2" stroke-linecap="round"/></svg></button>';
    var nextArrow = '<button type="button" class="slick-next slick-arrow new_call"><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle opacity="0.66" cx="22" cy="22" r="22" fill="white"/><path d="M20 18L24 22L20 26" stroke="#AFAFAF" stroke-width="2" stroke-linecap="round"/></svg></button>';

    // Init Slick for main slider
    $('.main-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        infinite: true,
        asNavFor: '.slider-thumb',
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        adaptiveHeight: true,
    });

    // Init Slick for thumbnail slider
    $('.slider-thumb').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.main-slider',
        dots: false,
        centerMode: false,
        focusOnSelect: true,
        responsive: [{
            breakpoint: 767,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
                swipe: false,
                centerMode: false
            }
        }]
    });

    // Ensure synchronization between sliders
    $('.main-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        if (nextSlide === 0 && currentSlide === slick.slideCount - 1) {
            // When going from last slide to first, also sync thumbnail
          if(currentSlide <5 ){
           $('.slick-track').css({
        'opacity': '1',
        'width': '408px',
        'transform': 'translate3d(0px, 0px, 0px)',
    });
          }
            $('.slider-thumb').slick('slickGoTo', 0);
        }
    });
}); 

$(document).ready(function() {
  $(".icon-zoom").click(function(){
    $(".main-slider .slick-track a.slick-slide.slick-current.slick-active").trigger("click");
  });    
});

$(document).ready(function() {
    // Function to generate a random number between min and max
    function getRandomNumber(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    // Set the minimum and maximum values
    var min = 7;
    var max = 22;

    // Check if the random number is already stored in sessionStorage
    var randomNumber = sessionStorage.getItem('randomNumber');

    if (!randomNumber) {
        // Generate a new random number if not already stored
        randomNumber = getRandomNumber(min, max);
        // Store the random number in sessionStorage
        sessionStorage.setItem('randomNumber', randomNumber);
    }

    // Update the text with the random number
    $(".custmrcart-tx").html('<span>!</span> In ' + randomNumber + '+ Customers Carts');
});

//CUSTOM ADD TO CART

//           $(document).ready(function() {
//   // Bind to the Add to Cart button click event
//   $(document).on('submit', 'form.product-form', function(event) {
//     event.preventDefault(); // Prevent the default form submission

//     var $form = $(this);
//     var $button = $form.find('[data-add-to-cart]');
//     var formData = $form.serialize(); // Serialize the form data

//     // Disable the button to prevent multiple submissions
//     $button.prop('disabled', true);
    
//     // Display a loading spinner (if you have one)
//     $button.find('[data-loader]').removeClass('hide');

//     // Send the AJAX request to add the product to the cart
//     $.ajax({
//       type: 'POST',
//       url: '/cart/add.js',
//       data: formData,
//       dataType: 'json',
//       success: function(response) {
//         // Successfully added to the cart
//         console.log('Product added to cart:', response);

//         // Update the cart UI (if you have a cart drawer or cart count to update)
//         updateCartUI(response);

//         // Enable the button again
//         $button.prop('disabled', false);

//         // Hide the loading spinner
//         $button.find('[data-loader]').addClass('hide');

//         // Optionally, show a success message or redirect to the cart page
//         alert('Product added to cart!');
//       },
//       error: function(error) {
//         console.log('Error adding product to cart:', error);

//         // Enable the button again
//         $button.prop('disabled', false);

//         // Hide the loading spinner
//         $button.find('[data-loader]').addClass('hide');

//         // Optionally, show an error message
//         alert('There was an issue adding the product to the cart. Please try again.');
//       }
//     });
//   });
// });

// // Function to update cart UI (this is just an example, customize as needed)
// function updateCartUI(response) {
//   // Update cart count, cart drawer, etc.
//   // For example, update cart count:
//   var newCartCount = response.items.length;
//   $('.cart-count').text(newCartCount);
// }



